// @ts-ignore
import { gql } from 'graphql-tag';
export const ComponentOnThisPageFragmentDoc = gql`
    fragment componentOnThisPage on ComponentOnThisPage {
  __typename
}
    `;